<template>
  <div class="download how-to-getcode">
    <div class="white-wrap">
      <div class="how-close" @click="closeDownloadAlert"></div>
      <div class="how-title">如何获取绑定码</div>
      <div class="how-text">请安装节点小宝设备端获取绑定码</div>
      <div class="device-type-wrap">
        <div class="device-type" @click="chooseFirmClick(2)">
          <div class="device-type-icon"></div>
          <div class="device-type-icon2"></div>
          <div class="device-type-text">NAS</div>
        </div>
        <div class="device-type device-type2" @click="chooseFirmClick(8)">
          <div class="device-type-icon"></div>
          <div class="device-type-icon2"></div>
          <div class="device-type-text">Windows</div>
        </div>
        <div class="device-type device-type3" @click="chooseFirmClick(9)">
          <div class="device-type-icon"></div>
          <div class="device-type-icon2"></div>
          <div class="device-type-text">Mac</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Download",
  methods: {
    closeDownloadAlert: function () {
      let _that = this;
      _that.$store.state.isShowDownload = 0;
    },
    chooseFirmClick: function (data) {
      let _that = this;
      _that.$store.state.isShowDownload = data;
    },
  },
};
</script>

<style lang="less" scoped>
.how-to-getcode {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  .white-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 580px;
    height: 300px;
    background-image: url("../../assets/remote/help4.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-shadow: 0px 4px 24px rgba(85, 97, 117, 0.4);
    border-radius: 8px;
    .how-close {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 24px;
      height: 24px;
      background-image: url("../../assets/remote/help7.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .how-title {
      margin-top: 44px;
      margin-left: 43px;
      width: 129px;
      height: 76px;
      // background-image: url("../../assets/remote/help.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-weight: 600;
      font-size: 28px;
      line-height: 34px;
      color: #163b7a;
      filter: drop-shadow(0px 6px 10px rgba(193, 222, 255, 0.42));
    }
    .how-text {
      position: relative;
      display: inline-block;
      margin-top: 5px;
      margin-left: 54px;
      font-weight: 600;
      font-size: 16px;
      line-height: 21px;
      color: #163b7a;
    }
    .how-text::before {
      content: "";
      position: absolute;
      top: -5px;
      left: -8px;
      width: 18px;
      height: 12px;
      background-image: url("../../assets/remote/help2.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .how-text::after {
      content: "";
      position: absolute;
      bottom: -3px;
      right: -7px;
      width: 18px;
      height: 12px;
      background-image: url("../../assets/remote/help3.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .device-type-wrap {
      margin-top: 30px;
      text-align: center;
      .device-type {
        display: inline-block;
        padding-top: 1px;
        vertical-align: top;
        width: 120px;
        height: 96px;
        border: 1px solid rgba(22, 59, 122, 0.6);
        border-radius: 8px;
        box-sizing: border-box;
        cursor: pointer;
        .device-type-icon {
          margin: 0 auto;
          margin-top: 15px;
          width: 36px;
          height: 36px;
          background-image: url("../../assets/remote/help5.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .device-type-icon2 {
          margin: 0 auto;
          margin-top: 10px;
          width: 24px;
          height: 2px;
          background: #1e478d;
          border-radius: 2px;
        }
        .device-type-text {
          margin-top: 2px;
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #163b7a;
        }
      }
      .device-type2 {
        margin-left: 12px;
        .device-type-icon {
          background-image: url("../../assets/remote/help6.png");
        }
      }
      .device-type3 {
        margin-left: 12px;
        .device-type-icon {
          background-image: url("../../assets/remote/help10.png");
        }
      }
      .device-type:hover {
        background: rgba(181, 212, 255, 0.2);
        box-shadow: 0px 4px 8px rgba(133, 143, 158, 0.2);
      }
    }
  }
}
</style>